import Cookies from 'js-cookie'
import { mapGetters, mapActions } from 'vuex'
import { isArray, isEmpty, trim, getByteLen, deepCopy } from '@/common/js/utils'
import { checkPlanName } from '@/api/common.model'

// 组件
import Mixcheck from '@/components/mixcheck'
import CheckItem from '@/components/mixcheck/check-item'
import CheckPlus from '@/components/mixcheck/check-plus'
import RadioItem from '@/components/mixcheck/radio-item'
import moduler from '@/components/moduler.vue'
import ErrorPop from '@/components/error-pop.vue'
import InputLen from '@/components/input/input-len.vue'
import InputNumberPlus from '@/components/input/input-number-plus'
import AutoComplete from '@/components/autocomplete/autocomplete.vue'

let Timer

export default {
  components: { Mixcheck, CheckItem, CheckPlus, RadioItem, moduler, ErrorPop, InputLen, InputNumberPlus, AutoComplete },
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      account: this.$store.state.Kuaishou.account,
      opId: Cookies.get('ch_op_id') || 0,

      check: null, // 计划名检查
      model: null,
      resData: [],
      loading: null,
      saving: null,
      formErr: null,
      errRes: []
    }
  },
  computed: {
    ...mapGetters('Kuaishou', ['subCurrent', 'subModules']),
    media() {
      return parseInt(this.$store.state.Kuaishou.media)
    },
    reqId() {
      return this.$route.query.req_id
    }
  },
  methods: {
    ...mapActions('Kuaishou', ['refreshDocTitle']),
    invalid(rules) {
      const arr = []
      const multRuleName = (name) => {
        const rule = name.split('/')
        if (rule.length > 3) return this[rule[0]][rule[1]][rule[2]][rule[3]]
        else if (rule.length > 2) return this[rule[0]][rule[1]][rule[2]]
        else return this[rule[0]][rule[1]]
      }
      if (!isArray(rules)) throw new Error('rule must be array')
      for (let i = 0; i < rules.length; i++) {
        let param
        let length
        const rule = rules[i]
        const ruleName = rule.name.indexOf('/') > -1 ? multRuleName(rule.name) : this[rule.name]
        if (typeof ruleName === 'undefined') continue
        if (typeof ruleName === 'string') {
          param = trim(ruleName)
          length = getByteLen(param)
        } else if (isArray(ruleName)) {
          param = ruleName
          length = param.length
        } else if (typeof ruleName === 'number') {
          param = length = ruleName
        } else {
          param = ruleName
          length = String(param).length
        }

        // 依赖
        if (rule.relyon) {
          const rely = rule.relyon.indexOf('/') > -1 ? multRuleName(rule.relyon) : this[rule.relyon]
          if (rely !== rule.relyvalue) continue
        }

        // 必填
        if ((rule.require && !param) || (rule.require && isEmpty(param))) {
          const msg = `${rule.desc}不能为空`
          this.formErr = true
          arr.push({ feild: rule.desc, msg })
          continue
        }

        // 长度判断
        if (typeof param === 'string' || isArray(param)) {
          if (param && rule.max < length) {
            const msg = `${rule.desc}不能多于${rule.max}个字符`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
          if (param && rule.min > length) {
            const msg = `${rule.desc}不能少于${rule.min}个字符`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }

        // 大小判断
        if (typeof param === 'number') {
          if (rule.max < length) {
            const msg = `${rule.desc}数值不能大于${rule.max}`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
          if (rule.min > length) {
            const msg = `${rule.desc}数值不能小于${rule.min}`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }

        // 正则
        if (param && rule.pattern) {
          const reg = new RegExp(rule.pattern, 'g')
          if (!reg.test(param)) {
            const msg = `${rule.desc}不是有效的值`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }
      }
      return arr
    },
    focusPlan() {
      Timer && clearTimeout(Timer)
    },
    blurPlan() {
      Timer = setTimeout(() => {
        this.checkPlan()
      }, 1000)
    },
    checkPlan() {
      const plan_name = deepCopy(this.plan.plan_name)
      if (isEmpty(plan_name)) return
      this.check = 'loading'
      checkPlanName({ planName: plan_name })
        .then((data) => {
          this.check = data ? 'success' : 'error'
        })
        .catch(() => {
          this.check = 'error'
        })
    },
    inputTrim(key, val, obj, fixed) {
      if (isEmpty(val)) return val
      val = trim(val)
      if (fixed) {
        val = parseFloat(val) * 1000
        val = Math.floor(val) / 1000
      } else val = parseInt(val)
      obj[key] = isEmpty(val) ? 0 : val
    },
    cannelError() {
      this.errRes = []
    },
    cannel() {
      this.closePageForm()
    },
    closePageForm() {
      this.$Message.info({
        content: '页面将 2 秒后自动关闭',
        duration: 2,
        onClose: () => {
          window.close()
        }
      })
    },
    beforeHandler() {
      window.onbeforeunload = function (event) {
        const msg = '您正在编辑内容，离开数据将丢失，确定要退出本页吗？'
        event.returnValue = msg
        return msg
      }
    },
    toTop() {
      this.$nextTick(() => {
        const contentElem = window.document.querySelector('.ivu-layout-content')
        contentElem.scrollTop = 0
        contentElem.addEventListener('scroll', this.handleScroll)
      })
    },
    toHref(scrollTop) {
      this.$nextTick(() => {
        const contentElem = window.document.querySelector('.ivu-layout-content')
        contentElem.scrollTop = scrollTop
        this.$store.commit('Kuaishou/setScroll', scrollTop)
      })
    },
    retry() {
      this.resData = []
      this.submitToNext()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.toTop()
      this.refreshDocTitle()
    })
  }
}
